import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useStrings } from '../../hooks/useStrings';
import { Link } from 'react-router-dom';

const HeroBanner: React.FC = () => {
  const { strings, loading } = useStrings();

  if (loading || !strings) {
    return (
      <section className="relative h-screen bg-gradient-to-r from-infinity-black to-infinity-purple flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative max-w-7xl mx-auto px-4 text-white">
          <div className="max-w-3xl space-y-6">
            <div className="h-20 skeleton"></div>
            <div className="h-8 skeleton w-2/3"></div>
            <div className="flex gap-4">
              <div className="h-16 w-48 skeleton"></div>
              <div className="h-16 w-32 skeleton"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="relative h-screen bg-gradient-to-r from-infinity-black to-infinity-purple flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-black opacity-50"></div>

      {/* Blobs decorativos */}
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-infinity-yellow rounded-full blur-3xl opacity-20 animate-float"></div>
      <div
        className="absolute -bottom-32 -left-16 w-96 h-96 bg-infinity-purple rounded-full blur-3xl opacity-30 animate-float"
        style={{ animationDelay: '2s' }}
      ></div>

      <div className="relative max-w-7xl mx-auto px-4 text-white">
        <div className="max-w-3xl">
          <h1
            className="text-5xl md:text-7xl font-bold mb-6 leading-tight opacity-0 animate-fade-in-up"
            style={{ animationDelay: '100ms' }}
          >
            {strings.heroBanner.title}
            <span className="text-infinity-yellow"> {strings.heroBanner.titleHighlight}</span>
            <br />{strings.heroBanner.titleContinuation}
          </h1>
          <p
            className="text-xl md:text-2xl mb-8 text-gray-300 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '250ms' }}
          >
            {strings.heroBanner.subtitle}
          </p>
          <div
            className="flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '400ms' }}
          >
            <Link
              to="/servicios"
              className="group btn-primary flex items-center justify-center space-x-2 text-lg py-4 px-8 hover:scale-105 hover:shadow-glow transition-all duration-300"
            >
              <span>{strings.heroBanner.exploreProductsButton}</span>
              <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
